<template>
  <Teleport to="body">
    <!-- Modal -->
    <Transition name="modal">
      <div v-if="showCloud" class="modal-mask">
        <div class="modal-container">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              @click="emits('showModalModelBellacloud', false)"
              aria-label="Close"
              style="font-size: 25px"
            ></button>
          </div>

          <div class="modal-body p-2">
            <div class="row border-bottom pb-2">
              <div class="col-12 title">
                {{ translate.saveBellaCloud }}
              </div>
              <div
                class="col-12 sub-title"
                v-if="storeUser.isLoggedIn && storeUser.isActiveUser"
              >
                {{ translate.saveAlbumInfo }}
              </div>
            </div>
            <div class="row pt-3 text-center" v-if="!storeUser.isLoggedIn">
              <span>{{ translate.loginToSave }}</span>
              <NuxtLink
                class="link-cloud mt-2"
                :to="{ name: 'language-login', params: { language: route.params.language } }"
                @click="emits('showModalModelBellacloud', false)"
              >
                {{ translate.login }}
              </NuxtLink>
            </div>
            <div class="row pt-3 text-center" v-else-if="!storeUser.isActiveUser">
              <span>{{ translate.onlySubscribers }}</span>
              <NuxtLink
                class="link-cloud mt-2"
                :to="{ name: 'language-assine', params: { language: route.params.language } }"
                @click="emits('showModalModelBellacloud', false)"
              >
                {{ translate.subscribe }}
              </NuxtLink>
            </div>
            <div class="row d-flex" v-else>
              <div class="row d-flex" v-if="list.data.length">
                <div
                  v-for="album in list.data"
                  class="col-lg-3 col-4 py-2 my-album text-center"
                  :key="album.id"
                  @click="selectAlbum(album)"
                >
                  <font-awesome
                    v-if="album.contem"
                    :icon="['fas', 'circle-check']"
                    class="album-check"
                  />
                  <img
                    v-else-if="album.capa"
                    :src="posterNoDominioPrincipal(album.capa) as string"
                    :alt="album.name"
                    class="rounded-circle position-absolute z-1 album-thumb"
                  />

                  <font-awesome
                    :icon="['far', 'folder']"
                    flip="horizontal"
                    style="color: #000000; font-size: 60px; cursor: pointer"
                  />
                  <br />
                  <div class="title-album cursor-pointer">{{ album.name }}</div>
                </div>
              </div>
              <div
                class="col-lg-3 col-4 py-2 my-album text-center"
                v-if="tipoDoItem === 'foto'"
                @click="selectFavoriteAlbum()"
              >
                <font-awesome
                  :icon="['fas', 'heart']"
                  class="album-check"
                />

                <font-awesome
                  :icon="['far', 'folder']"
                  flip="horizontal"
                  style="color: #000000; font-size: 60px; cursor: pointer"
                />
                <br />
                <div class="title-album cursor-pointer">
                  {{ translate.goFavoriteModels }}
                </div>
              </div>
              <div class="text-center mt-3" v-if="loadingMyAlbum">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div
                class="col-lg-6 col-6 d-flex align-items-center justify-content-center cursor-pointer"
                @click="newAlbum(true)"
              >
                <div class="icon-new-album"></div>
                {{ translate.newAlbum }}
              </div>
              <vue-awesome-paginate
                class="mt-2"
                v-if="list.data.length"
                :modelValue="list.current_page"
                :total-items="list.total"
                :items-per-page="list.per_page"
                :max-pages-shown="3"
                @click="onClickHandlerMyAlbuns"
              />
            </div>
          </div>
        </div>
        <ModalMessages
          @showModalMessages="showModalMessages"
          :options="options"
        />
        <ModalNewAlbumBellaCloud
          :show="modalNewAlbum"
          @showModalClose="newAlbum"
          @showModalMessages="showModalMessages"
        />
      </div>
    </Transition>
  </Teleport>
</template>

<script lang="ts" setup>
import tradutor from "@/tradutors/bellacloud";
import api from "@/api";
import ModalNewAlbumBellaCloud from "@/components/Modais/ModalNewAlbumBellaCloud.vue";
import ModalMessages from "@/components/Modais/ModalMessages.vue";
import { posterNoDominioPrincipal } from "@/utils/ensaioSSR";

const props = defineProps(["showCloud", "imageIdSelected", "video", "tipo"]);
const emits = defineEmits(["showModalModelBellacloud"]);

const storeUser = userStore();
const route = useRoute();

const translate = computed(() => {
  if ((route.params.language) === "pt-br") {
    return tradutor.portugues;
  } else {
    return tradutor.ingles;
  }
});

// foto | video | makingof | live; quem ainda passa só `video` continua funcionando.
const tipoDoItem = computed(() => props.tipo ?? (props.video ? "video" : "foto"));

watch(
  () => props.showCloud,
  (aberto) => {
    if (aberto && storeUser.isLoggedIn && storeUser.isActiveUser) {
      getMyAlbums();
    }
  }
);

const list = ref({
  current_page: 1,
  total: 1,
  per_page: 1,
  data: <any>[],
});
const modalNewAlbum = ref(false);
const options = ref({
  showModal: false,
  titleModal: "",
  textBodyModal: "",
  textButtonModal: "",
});
const loadingMyAlbum = ref(false);

async function getMyAlbums(page: number | string = "") {
  loadingMyAlbum.value = true;
  api
    .get(
      `v1/bellacloud/getMyAlbuns?page=${page}&tipo=${tipoDoItem.value}&item=${props.imageIdSelected}&layout=novo`
    )
    .then(({ data }) => {
      list.value = data;
    })
    .finally(() => (loadingMyAlbum.value = false));
}
async function onClickHandlerMyAlbuns(page: number) {
  await getMyAlbums(page);
}
function newAlbum(val: boolean) {
  modalNewAlbum.value = val;

  if (!val) getMyAlbums();
}
function avisa(texto: string, titulo = "") {
  showModalMessages({
    message: {
      show: true,
      title: titulo,
      textBoby: texto,
      textButton: translate.value.btnClose,
    },
  });
}
function avisaErro(err: any) {
  avisa(err?.response?.data?.message ?? translate.value.errorBellaCloudPhoto, "Error");
}
async function selectFavoriteAlbum() {
  api
    .post("v1/bellacloud/favoriteModel", { photoId: props.imageIdSelected })
    .then(() => avisa(translate.value.successBellaCloudPhoto))
    .catch(avisaErro);
}
function showModalMessages(data: any) {
  options.value.showModal = data.message.show;
  options.value.titleModal = data.message.title;
  options.value.textBodyModal = data.message.textBoby;
  options.value.textButtonModal = data.message.textButton;
}
function selectAlbum(album: any) {
  const pedido = album.contem
    ? api.delete(
        `v1/bellacloud/item/${album.id}/${tipoDoItem.value}/${props.imageIdSelected}`
      )
    : api.post("v1/bellacloud/item", {
        tipo: tipoDoItem.value,
        itemId: props.imageIdSelected,
        albumId: album.id,
        locale: route.params.language,
      });

  pedido
    .then(() => {
      avisa(album.contem ? translate.value.successRemoved : translate.value.successBellaCloudPhoto);
      getMyAlbums(list.value.current_page);
    })
    .catch(avisaErro);
}
</script>

<style scoped lang="css">
.icon-new-album {
  background-image: url("../../assets/img/icone-circulo-pontilhado-cruz-meio.svg");
  width: 54px;
  height: 54px;
  margin-inline-end: 15px;
}

.my-album {
  color: #444444;
}

.album-check {
  position: absolute;
  z-index: 1;
  margin-top: 40px;
  margin-left: 18px;
  width: 25px;
  height: 25px;
  color: #6ca727;
  cursor: pointer;
  background-color: white;
  border-radius: 50%;
}

.album-thumb {
  margin-top: 40px;
  margin-left: 18px;
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.link-cloud {
  color: #b20000;
  font-weight: 600;
}

.my-album > img {
  object-fit: fill;
}

.title {
  color: #b20000;
  font-weight: 600;
  text-align: center;
}

.sub-title {
  color: #aaaaaa;
  font-weight: 300;
  text-align: center;
  font-size: 12px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
  overflow-y: auto;
}

.modal-container {
  width: 40%;
  margin: auto;
  padding: 20px 10px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header {
  align-items: center;
  justify-content: end;
}

.modal-body {
  margin: 20px 0;
}

.vertical-w {
  width: 100%;
  object-fit: cover;
}

.horizontal-w {
  width: 100%;
}

.modal-footer {
  justify-content: center;
}

.modal-default-button {
  float: right;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.title-album {
  font-size: 12px;
  padding-top: 10px;
}

.form-group input {
  padding: 10px 20px;
  border-radius: 30px;
  margin-bottom: 15px;
  background-color: #f8f8f8;
  font-size: small;
}

.btn-outline-secondary {
  font-size: 15px;
  color: white;
  border-radius: 30px;
  background-color: black;
  border: none;
}

/* regras mobile 992vp */
@media screen and (max-width: 992px) {
  .modal-container {
    width: 90%;
  }
}
</style>
